export interface ISWP_FORMULA {
  totalInvestmentValue: number | undefined;
  withdrawalAmountValue: number | undefined;
  expectedReturnsValue: number | undefined;
  tenureValue: number | undefined;
}

export const SWP_FORMULA = ({
  totalInvestmentValue,
  withdrawalAmountValue,
  expectedReturnsValue,
  tenureValue,
}: ISWP_FORMULA) => {
  if (
    !totalInvestmentValue ||
    !withdrawalAmountValue ||
    !expectedReturnsValue ||
    !tenureValue ||
    Number(totalInvestmentValue) < 0 ||
    Number(withdrawalAmountValue) < 0 ||
    Number(expectedReturnsValue) < 0 ||
    Number(tenureValue) <= 0
  ) {
    return {
      finalValue: 0,
      totalWithdrawals: 0,
      totalInvestment: 0,
      totalReturns: 0,
      warning: 'no',
    };
  }

  const investment = Number(totalInvestmentValue);
  const withdrawal = Number(withdrawalAmountValue);
  const years = Number(tenureValue);
  const expectedReturns = Number(expectedReturnsValue);
  const months = years * 12;

  const finalValue = Math.round(
    investment * Math.pow(1 + expectedReturns / 100, years) -
      (withdrawal *
        (Math.pow(
          1 + (Math.pow(1 + expectedReturns / 100, 1 / 12) - 1),
          months
        ) -
          1)) /
        (Math.pow(1 + expectedReturns / 100, 1 / 12) - 1)
  );

  if (finalValue < 0) {
    return {
      finalValue: 0,
      totalWithdrawals: 0,
      totalInvestment: 0,
      totalReturns: 0,
      warning: 'yes',
    };
  }

  const totalWithdrawals = withdrawal * months;

  const returns = Math.round(totalWithdrawals + finalValue - investment);

  return {
    finalValue,
    totalWithdrawals,
    totalInvestment: investment,
    totalReturns: returns,
    warning: 'no',
  };
};
